import { mapGetters, mapState } from "vuex"

const appearanceSettingsMixin = {
  data() {
    return {
      selectorMap: {}
    }
  },
  computed: {
    ...mapGetters("builder", ["getPageSelector"]),
    ...mapState("builder", ["appearanceDevice"]),
    setAreaTopic() {
      return this.$store.state.builder.setAreaTopic
    }
  },
  watch: {
    appearanceDevice() {
      this.$store.commit("builder/clearOutlines")
      this.outline()
    },
    setAreaTopic() {
      this.$store.commit("builder/clearOutlines")
      this.outline()
    }
  },
  methods: {
    outline() {
      if (this.setAreaTopic && this.setAreaTopic in this.selectorMap) {
        this.$store.commit("builder/addOutline", {
          device: this.appearanceDevice,
          selector: `${this.getPageSelector} ${this.selectorMap[this.setAreaTopic]}`
        })
      }
    }
  },
  beforeDestroy() {
    this.$store.commit("builder/clearOutlines")
  },
  mounted() {
    this.outline()
  }
}

export default appearanceSettingsMixin
